export const EntidadRecaudadora = [
  {
    name: 'Todas',
    value: 0
  },
  {
    name: 'Principal AGF',
    value: 1
  },
  {
    name: 'Principal Vida',
    value: 2
  }
]